define('taoQtiItem/qtiXmlRenderer/renderers/interactions/Prompt',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'prompt',
        template : tpl
    };
});
